import { BannerId, BannerSiteLinksId } from '../../typings/banners';
import { BannerSiteLinksEditorData } from '../../typings/bannersEditState';
import {
    GdAddSitelinkInput,
    GdAddSitelinkSetInput
} from '../../typings/graphql-grid';

export function mapBannersSiteLinksToApiFormat(
    bannersId: BannerId[],
    siteLinksData: Record<BannerSiteLinksId, BannerSiteLinksEditorData>
): GdAddSitelinkSetInput[] {
    return bannersId.map(id => {
        const sitelinksAll = mapSitelinksDataToApiFormat(siteLinksData[id]);
        // на сервер поедет только заполненная ссылка
        const sitelinks: GdAddSitelinkInput[] = sitelinksAll.reduce(
            (result: GdAddSitelinkInput[], sitelink) => {
                if (sitelink !== null) {
                    result.push(sitelink);
                }

                return result;
            },
            []
        );

        return {
            sitelinks
        };
    });
}

export const mapSitelinksDataToApiFormat = (
    sitelinks: BannerSiteLinksEditorData
): Array<GdAddSitelinkInput | null> => {
    const result: Array<GdAddSitelinkInput | null> = [];

    sitelinks.items.forEach(siteLink => {
        if (
            siteLink.link ||
            siteLink.title ||
            siteLink.descr ||
            siteLink.turbo
        ) {
            result.push({
                title: siteLink.title,
                href:
                    siteLink.link.length > 0
                        ? siteLink.protocol + siteLink.link
                        : '',
                description:
                    sitelinks.isDescriptionChecked && siteLink.descr.length > 0
                        ? siteLink.descr
                        : null,
                turbolandingId: siteLink.turbo
                    ? siteLink.turbo.landingId
                    : undefined
            });
        } else {
            result.push(null);
        }
    });

    return result;
};
